import { useEffect, useState } from "react";

const useDebounceValue = (value: any, waitTime: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, waitTime);

    return () => {
      clearTimeout(handler);
    };
  }, [value, waitTime]);

  return debouncedValue;
};

export default useDebounceValue;
